import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import 'react-toastify/dist/ReactToastify.css';
import CreateCountryForm from './CreateCountryForm';

const CreateCountryPopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <span onClick={toggle} className="cursor-pointer">
        <i className="bx bx-plus"></i>
      </span>

      <Modal
        size="lg"
        isOpen={isOpen}
        toggle={toggle}
        backdrop="static"
        className="modal-dialog-centered"
      >
        <ModalHeader toggle={toggle} className="border-bottom pb-3">
          Add New Country
        </ModalHeader>
        <ModalBody>
          <CreateCountryForm handleClose={toggle} isFromPopup={true} />
        </ModalBody>
      </Modal>
    </>
  );
};

export default CreateCountryPopup;
